<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="col-md-12" v-if="step == 1">
        <div class="card card_full_window vm_create_page ">
          <div class="card-body">
            <div class="common_content_wrap no_left_content">
              <div class="common_content_right">
                <div class="vm_list_content">
                  <div class="common_dropdown dropdown_no_radius mr_10" v-if="customer.selected_service_id == 2">
                    <div class="d_flex_start pt_10 pb_10">
                      <h6 class="d_flex_start w-100 common_subtitle">Select Platform</h6>
                    </div>
                    <div class="btn-group dropdown-center dropdown-fill-text">
                      <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown"
                              aria-expanded="false">
                        <span v-if="selectedPlatform">{{ selectedPlatform.value }}</span>
                      </button>
                      <ul class="dropdown-menu no_arrow">
                        <li v-for="(serverPlatform, index) in serverPlatforms" :key="'server_platform_'+index"
                            @click.prevent="changePlatform(serverPlatform)">
                          <button class="dropdown-item" type="button"><span>{{ serverPlatform.value }}</span></button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="d_flex_start pt_10 pb_10">
                    <h6 class="d_flex_start w-100 common_subtitle">Select Region</h6>
                  </div>
                  <div class="common_dropdown dropdown_no_radius pb_10">
                    <div class="btn-group dropdown-center dropdown-fill-text">
                      <button type="button" class="btn btn-secondary dropdown-toggle " data-bs-toggle="dropdown" aria-expanded="false">
                        <span v-if="selectedRegion">{{ selectedRegion.name }}</span>
                      </button>
                      <ul class="dropdown-menu no_arrow">
                        <li v-for="(serverRegion, index) in serverRegions" :key="'server_region_'+index" @click.prevent="changeRegion(serverRegion)">
                          <button class="dropdown-item" type="button"> <span>{{ serverRegion.name }}</span>  </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <template v-if="form.kt_platform == 'g'">
                    <div class="d_flex_start pt_10">
                      <h6 class="d_flex_start w-100 common_subtitle">Select OS</h6>
                    </div>
                    <div class="os_list pt_10 pb_10">
                      <div class="os_list_inner" :class="{'active' : form.os_type == 'ubuntu'}" @click.prevent="changeOsType('ubuntu')">
                        <div class="inner_wrap">
                          <div class="text">UBUNTU</div>
                          <div class="image"><img src="assets/media/images/service-page/os-list6.png" alt=""></div>
                        </div>
                      </div>
                      <div class="os_list_inner" :class="{'active' : form.os_type == 'debian'}" @click.prevent="changeOsType('debian')">
                        <div class="inner_wrap">
                          <div class="text">DEBIAN</div>
                          <div class="image"><img src="assets/media/images/service-page/os-list2.png" alt=""></div>
                        </div>
                      </div>
                      <div class="os_list_inner" :class="{'active' : form.os_type == 'win'}" @click.prevent="changeOsType('win')">
                        <div class="inner_wrap">
                          <div class="text">WINDOWS</div>
                          <div class="image"><img src="assets/media/images/service-page/os-list7.png" alt=""></div>
                        </div>
                      </div>
                      <div class="os_list_inner" :class="{'active' : form.os_type == 'rocky'}" @click.prevent="changeOsType('rocky')">
                        <div class="inner_wrap">
                          <div class="text">ROCKY</div>
                          <div class="image"><img src="assets/media/images/service-page/os-list5.png" alt=""></div>
                        </div>
                      </div>
                    </div>
                    <div class="d_flex_start pt_20 pb_10">
                      <h6 class="d_flex_start w-100 common_subtitle">Select Version</h6>
                    </div>
                    <div class="common_dropdown dropdown_no_radius pb_20">
                      <div class="btn-group dropdown-center dropdown-fill-text">
                        <button type="button" class="btn btn-secondary dropdown-toggle " data-bs-toggle="dropdown" aria-expanded="false">
                          <span v-if="selectedProductType">{{ selectedProductType.template_desc }}</span>
                        </button>
                        <ul class="dropdown-menu no_arrow">
                          <li v-for="(serverProductType, index) in serverProductTypes" :key="'server_region_'+index" @click.prevent="changeProductType(serverProductType)">
                            <button class="dropdown-item" type="button"> <span>{{ serverProductType.template_desc }}</span>  </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="row">
                      <div class="d_flex_start pt_10 pb_10">
                        <h6 class="d_flex_start w-100 common_subtitle">Type</h6>
                      </div>
                      <div class="common_dropdown dropdown_no_radius pb_10">
                        <div class="btn-group dropdown-center dropdown-fill-text">
                          <button type="button" class="btn btn-secondary dropdown-toggle " data-bs-toggle="dropdown" aria-expanded="false">
                            <span v-if="selectedDType">{{ selectedDType.display_name }}</span>
                          </button>
                          <ul class="dropdown-menu no_arrow">
                            <li v-for="(serverDType, index) in serverDTypes" :key="'server_region_'+index" @click.prevent="changeDType(serverDType)">
                              <button class="dropdown-item" type="button"> <span>{{ serverDType.display_name }}</span>  </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="d_flex_start pt_10">
                        <h6 class="d_flex_start w-100 common_subtitle">Select OS</h6>
                      </div>
                      <div class="os_list pt_10 pb_10">
                        <template v-for="(children, cIndex) in serverDTypeChildren" :key="'os_d_type_'+cIndex">
                          <div class="os_list_inner" :class="{'active' : form.os_d_type == children.display_name}" @click.prevent="changeDOsType(children)">
                            <div class="inner_wrap">
                              <div class="text">{{ children.display_name }}</div>
                              <div class="image">
                                <img v-if="children.display_name == 'Ubuntu'" src="assets/media/images/service-page/os-list6.png" alt="">
                                <img v-if="children.display_name == 'Windows'" src="assets/media/images/service-page/os-list7.png" alt="">
                                <img v-if="children.display_name == 'DEBIAN'" src="assets/media/images/service-page/os-list2.png" alt="">
                                <img v-if="children.display_name == 'Rocky'" src="assets/media/images/service-page/os-list5.png" alt="">
                                <img v-if="children.display_name == 'Red Hat Linux'" src="assets/media/images/service-page/os-list4.png" alt="">
                                <img v-if="children.display_name == 'MongoDB'" src="assets/media/images/service-page/os-list1.png" alt="">
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div class="d_flex_start pt_20 pb_10">
                        <h6 class="d_flex_start w-auto common_subtitle">Select Version</h6>
                      </div>
                      <div class="common_dropdown w-auto dropdown_no_radius pb_20">
                        <div class="btn-group dropdown-center dropdown-fill-text">
                          <button type="button" class="btn btn-secondary dropdown-toggle w-auto" data-bs-toggle="dropdown" aria-expanded="false">
                            <span v-if="serverDTypeChildrenList">{{ serverDTypeChildrenList.display_name }}</span>
                          </button>
                          <ul class="dropdown-menu no_arrow">
                            <li v-for="(ChildrenList, index) in serverDTypeChildrenLists" :key="'server_children_'+index" @click.prevent="changeDProductType(ChildrenList)">
                              <button class="dropdown-item" type="button"> <span>{{ ChildrenList.display_name }}</span>  </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div class="d_flex_end custom_border_top mt_20 pt_20">
                    <button type="button" class="btn btn-outline-danger mr_5" @click.prevent="cancelOperation()">Cancel</button>
                    <button type="button" class="btn btn-primary btn-md  width_100p" @click.prevent="stepChange(2)">Next</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" v-if="step == 2 && form.kt_platform == 'g'">
        <div class="card card_full_window vm_checkout_page ">
          <div class="card-body">
            <div class="no_left_content">
              <h5 class="common_subtitle pb_20 border-lightgray-bottom mb_20">VM Configuration </h5>
              <div class="vm_checkout_content">
                <div class="vm_checkout_left">
                  <div class="mb-3">
                    <label for="region" class="col-form-label">Region</label>
                    <input type="text" class="form-control" id="region" :value="selectedRegion?.name" readonly>
                  </div>
                  <div class="mb-3">
                    <label for="server_name" class="col-form-label">VM Name</label>
                    <input type="text" class="form-control" id="server_name" v-model="form.server_name">
                    <v-errors :errors="errorFor('server_name')"></v-errors>
                  </div>

                  <div class="mb-3">
                    <label for="server_product_type_id" class="col-form-label">Specification (Model Core RAM -- Space)</label>
                    <select class="form-select" id="server_product_type_id" v-model="form.server_product_type_id" @change="changeSpecification">
                      <option  v-for="(osProductType, index) in osProductTypes" :key="'os_product_type_'+index" :value="osProductType.id">
                        {{ osProductType.service_offering_desc }} -- {{ osProductType.disk_offering_desc }}
                      </option>
                    </select>
                    <v-errors :errors="errorFor('server_product_type_id')"></v-errors>
                  </div>
                  <div class="mb-3">
                    <label for="ssh_keypair_id" class="col-form-label">Ssh keypair</label>
                    <div class="d-flex align-items-center">
                      <select class="form-select me-4" id="ssh_keypair_id" v-model="form.ssh_keypair_id">
                        <option value="">Select ssh keypair</option>
                        <option  v-for="(sshKeypair, index) in sshKeypairs" :key="'ssh_keypair_'+index" :value="sshKeypair.id">
                          {{ sshKeypair.name }}
                        </option>
                      </select>
                      <button class="btn btn-outline-primary btn-sm width_100p" @click="openAddSshModal">+ Add</button>
                      <v-errors :errors="errorFor('ssh_keypair_id')"></v-errors>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="inputEmail3" class="col-form-label">Billing type</label>
                    <select class="form-select" v-model="form.billing_type">
                      <option value="monthly">Monthly</option>
                      <option value="hourly">Hourly</option>
                    </select>
                    <v-errors :errors="errorFor('billing_type')"></v-errors>
                  </div>
                </div>
                <div class="vm_checkout_right">
                  <div class="vm_checkout_right_wrap">
                    <h5 class="common_subtitle">Estimated Bill </h5>
                    <div class="checkout_right_inner">
                      <div class="d_flex_btwn inner_title">
                        <span>Server details</span>
                        Kt cloud price: ￦ {{ getKtCloudPrice }}
                        <br>
                        Vlan24 price: ￦ {{ getVlan24Price }}
                      </div>
                      <div class="vm_checkout_table">
                        <table class="table">
                          <tbody>
                          <tr>
                            <td>Operating system</td>
                            <td>{{ selectedProductType?.template_desc }}</td>
                          </tr>
                          <tr>
                            <td>Specification</td>
                            <td>{{ selectedOsProductType?.service_offering_desc }}</td>
                          </tr>
                          <tr>
                            <td>Space</td>
                            <td>{{ selectedOsProductType?.disk_offering_desc }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="checkout_subtotal">
                        <p class="mb_5">Total estimated bill( {{ form.billing_type }} )</p>
                        <h2 class="subtotal">{{ formatPrice(getVlan24Price) }}</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d_flex_btwn custom_border_top mt_20 pt_20 pb_20">
              <div class="d_flex_start">
                <button type="button" class="btn btn-outline-primary btn-md  width_100p" @click.prevent="stepChange(1)">Back</button>
              </div>
              <div class="d_flex_start">
                <button type="button" class="btn btn-outline-danger mr_5" @click.prevent="cancelOperation()">Cancel</button>
                <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" @click.prevent="submit">Launch</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="step == 2 && form.kt_platform == 'd'" class="col-md-12">
        <div class="card card_full_window vm_checkout_page ">
          <div class="card-body">
            <div class="no_left_content">
              <h5 class="common_subtitle pb_20 border-lightgray-bottom mb_20">VM Configuration </h5>
              <div class="vm_checkout_content">
                <div class="vm_checkout_left">
                  <div class="mb-3">
                    <label for="region" class="col-form-label">Region</label>
                    <input type="text" class="form-control" id="region" :value="selectedRegion?.name" readonly>
                  </div>
                  <div class="mb-3">
                    <label for="server_name" class="col-form-label">VM Name</label>
                    <input type="text" class="form-control" id="server_name" v-model="form.server_name">
                    <v-errors :errors="errorFor('server_name')"></v-errors>
                  </div>
                  <div class="row">
                    <div class="col_4">
                      <div class="mb-3">
                        <label for="kt_tier_id" class="col-form-label">Tier</label>
                        <select class="form-select" id="kt_tier_id" v-model="form.kt_tier_id">
                          <option  v-for="(ktTier, index) in ktTiers" :key="'kt_tier_'+index" :value="ktTier.id">
                            {{ ktTier.name }}
                          </option>
                        </select>
                        <v-errors :errors="errorFor('kt_tier_id')"></v-errors>
                      </div>
                    </div>
                    <div class="col_4">
                      <div class="mb-3">
                        <label for="volume_type" class="col-form-label">Root volume type</label>
                        <select class="form-select" id="volume_type" v-model="form.volume_type">
                          <option value="SSD">SSD</option>
                          <option value="HDD">HDD</option>
                        </select>
                        <v-errors :errors="errorFor('volume_type')"></v-errors>
                      </div>
                    </div>
                    <div class="col_4">
                      <div class="mb-3">
                        <label for="volume_size" class="col-form-label">Root volume size</label>
                        <select class="form-select" id="volume_size" v-model="form.volume_size">
                          <option value="50">50GB</option>
                          <option value="100">100GB</option>
                        </select>
                        <v-errors :errors="errorFor('volume_size')"></v-errors>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col_6">
                      <div class="mb-3">
                        <label for="kt_d_product_type_id" class="col-form-label">Specification (Core RAM -- Space)</label>
                        <select class="form-select" id="kt_d_product_type_id" v-model="form.kt_d_product_type_id" @change="changeDSpecification">
                          <option  v-for="(osProductType, index) in osDProductTypes" :key="'os_product_type_'+index" :value="osProductType.id">
                            {{ osProductType.name }}
                          </option>
                        </select>

                        <v-errors :errors="errorFor('kt_d_product_type_id')"></v-errors>
                      </div>
                    </div>
                    <div class="col_6">
                      <div class="mb-3">
                        <label for="kt_d_image_id" class="col-form-label">Image</label>
                        <select class="form-select" id="kt_d_image_id" v-model="form.kt_d_image_id">
                          <option  v-for="(dImage, index) in dImages" :key="'d_image_'+index" :value="dImage.id">
                            {{ dImage.name }}
                          </option>
                        </select>
                        <v-errors :errors="errorFor('kt_d_image_id')"></v-errors>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="ssh_keypair_id" class="col-form-label">Ssh keypair</label>
                    <div class="d-flex align-items-center">
                      <select class="form-select me-4" id="ssh_keypair_id" v-model="form.ssh_keypair_id">
                        <option value="">Select ssh keypair</option>
                        <option  v-for="(sshKeypair, index) in sshKeypairs" :key="'ssh_keypair_'+index" :value="sshKeypair.id">
                          {{ sshKeypair.name }}
                        </option>
                      </select>
                      <button class="btn btn-outline-primary btn-sm width_100p" @click="openAddSshModal">+ Add</button>
                      <v-errors :errors="errorFor('ssh_keypair_id')"></v-errors>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="inputEmail3" class="col-form-label">Billing type</label>
                    <select class="form-select" v-model="form.billing_type">
                      <option value="monthly">Monthly</option>
                      <option value="hourly">Hourly</option>
                    </select>
                    <v-errors :errors="errorFor('billing_type')"></v-errors>
                  </div>
                </div>
                <div class="vm_checkout_right">
                  <div class="vm_checkout_right_wrap">
                    <h5 class="common_subtitle">Estimated Bill </h5>
                    <div class="checkout_right_inner">
                      <div class="d_flex_btwn inner_title">
                        <span>Server details</span>
                        Kt cloud price:
                        <template v-if="form.billing_type == 'monthly' && generatedMonthlyPrice">{{ formatPrice(generatedMonthlyPrice) }}</template>
                        <template v-if="form.billing_type == 'hourly' && generatedHourlyPrice">{{ formatPrice(generatedHourlyPrice) }}</template>
                        <br>
                        Vlan24 price:
                        <template v-if="form.billing_type == 'monthly' && generatedMonthlyCommissionPrice">{{ formatPrice(generatedMonthlyCommissionPrice) }}</template>
                        <template v-if="form.billing_type == 'hourly' && generatedHourlyCommissionPrice">{{ formatPrice(generatedHourlyCommissionPrice) }}</template>
                      </div>
                      <div class="vm_checkout_table">
                        <table class="table">
                          <tbody>
                          <tr>
                            <td>Operating system</td>
                            <td>{{ serverDTypeChildrenList?.display_name }}</td>
                          </tr>
                          <tr>
                            <td>Specification</td>
                            <td>{{ selectedDOsProductType?.name }}</td>
                          </tr>
                          <tr>
                            <td>Volume type</td>
                            <td>{{ form.volume_type }}</td>
                          </tr>
                          <tr>
                            <td>Space</td>
                            <td>{{ form.volume_size }}GB</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="checkout_subtotal">
                        <template v-if="form.billing_type == 'monthly' && generatedMonthlyCommissionPrice">
                          <p class="mb_5">Total estimated bill( {{ form.billing_type }} )</p>
                          <h2 class="subtotal">{{ formatPrice(generatedMonthlyCommissionPrice) }}</h2>
                        </template>
                        <template v-if="form.billing_type == 'hourly' && generatedHourlyCommissionPrice">
                          <p class="mb_5">Total estimated bill( {{ form.billing_type }} )</p>
                          <h2 class="subtotal">{{ formatPrice(generatedHourlyCommissionPrice) }}</h2>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d_flex_btwn custom_border_top mt_20 pt_20 pb_20">
              <div class="d_flex_start">
                <button type="button" class="btn btn-outline-primary btn-md  width_100p" @click.prevent="stepChange(1)">Back</button>
              </div>
              <div class="d_flex_start">
                <button type="button" class="btn btn-outline-danger mr_5" @click.prevent="cancelOperation()">Cancel</button>
                <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" v-if="form.kt_platform == 'g'" @click.prevent="submit">Launch</button>
                <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" v-else @click.prevent="submitDServerCreation">Launch</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BaseModal
        v-if="isShowContactModal"
        title="Create SSH Key Pair"
        :closeModal="closeModal"
    >
      <SshKeyPairForm
          :closeModal="closeModal"
          :loadData="loadSshkeypairs"
          @setCreatedRecord="setCreatedRecord"
      />
    </BaseModal>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
import SshKeyPairForm from "@/views/services/sshKeypair/SshKeyPairForm.vue";
import BaseModal from "@/components/BaseModal.vue";
export default {
  name: 'CloudServerForm',
  components: {BaseModal, SshKeyPairForm, LoaderMaskComponent},
  data(){
    return {
      lyLoading: false,
      selectedPlatform: null,
      step: 1,
      form: {
        kt_platform: '',
        server_region_id: '',
        server_name: '',
        ssh_keypair_id: '',
        os_type: 'ubuntu',
        os_d_type: 'Ubuntu',
        server_product_type_id: '',
        kt_d_product_type_id: '',
        kt_d_image_id: '',
        kt_tier_id: '',
        volume_type: 'HDD',
        volume_size: '50',
        billing_type: 'hourly',
      },
      serverRegions: [],
      sshKeypairs: [],
      selectedRegion: null,
      serverProductTypes: [],
      selectedProductType: null,
      osProductTypes: [],
      selectedOsProductType: null,
      serverDTypes: [],
      selectedDType: null,
      serverDTypeChildren: [],
      serverDTypeChildrenList: null,
      serverDTypeChildrenLists: [],
      osDProductTypes: [],
      selectedDOsProductType: null,
      ktTiers: [],
      ktDPriceSettings: [],
      dImages: [],
      isShowContactModal: false,
    }
  },
  computed:{
    ...mapGetters({
      customer: 'auth/getUserInfo',
    }),
    eneratedMonthlyPrice() {
      if(this.form.volume_type == 'HDD'){
        let priceSetting = this.ktDPriceSettings.filter(price => price.type == 'HDD')
        let price = 0
        if(this.form.volume_size == 50){
          price =  this.selectedDOsProductType.monthly_price + priceSetting[0].monthly_add_price
        }else if(this.form.volume_size == 100){
          price = this.selectedDOsProductType.monthly_price + priceSetting[0].monthly_add_price + priceSetting[0].monthly_extra_price
        }else{
          price = 0
        }
        return Math.ceil(price)
      }else{
        let priceSetting = this.ktDPriceSettings.filter(price => price.type == 'SSD')
        let price = 0
        if(this.form.volume_size == 50){
          price = this.selectedDOsProductType.monthly_price + priceSetting[0].monthly_add_price
        }else if(this.form.volume_size == 100){
          price = this.selectedDOsProductType.monthly_price + priceSetting[0].monthly_add_price + priceSetting[0].monthly_extra_price
        }else{
          price = 0
        }
        return Math.ceil(price)
      }
    },
    generatedHourlyPrice() {
      if(this.form.volume_type == 'HDD'){
        let priceSetting = this.ktDPriceSettings.filter(price => price.type == 'HDD')
        let price = 0
        if(this.form.volume_size == 50){
          price = this.selectedDOsProductType.hourly_price + priceSetting[0].hourly_add_price
        }else if(this.form.volume_size == 100){
          price = this.selectedDOsProductType.hourly_price + priceSetting[0].hourly_add_price + priceSetting[0].hourly_extra_price
        }else{
          price = 0
        }
        return Math.ceil(price)
      }else{
        let priceSetting = this.ktDPriceSettings.filter(price => price.type == 'SSD')
        let price = 0
        if(this.form.volume_size == 50){
          price = this.selectedDOsProductType.hourly_price + priceSetting[0].hourly_add_price
        }else if(this.form.volume_size == 100){
          price = this.selectedDOsProductType.hourly_price + priceSetting[0].hourly_add_price + priceSetting[0].hourly_extra_price
        }else{
          price = 0
        }
        return Math.ceil(price)
      }
    },
    generatedMonthlyCommissionPrice() {
      if(this.form.volume_type == 'HDD'){
        let priceSetting = this.ktDPriceSettings.filter(price => price.type == 'HDD')
        let price = 0
        if(this.form.volume_size == 50){
          let cPrice = this.selectedDOsProductType.monthly_price + priceSetting[0].monthly_add_price
          price =  cPrice - (cPrice * (this.customer.commission/100))
        }else if(this.form.volume_size == 100){
          let cPrice = this.selectedDOsProductType.monthly_price + priceSetting[0].monthly_add_price + priceSetting[0].monthly_extra_price
          price = cPrice - (cPrice * (this.customer.commission/100))
        }else{
          price = 0
        }
        return Math.ceil(price)
      }else{
        let priceSetting = this.ktDPriceSettings.filter(price => price.type == 'SSD')
        let price = 0
        if(this.form.volume_size == 50){
          let cPrice = this.selectedDOsProductType.monthly_price + priceSetting[0].monthly_add_price
          price =  cPrice - (cPrice * (this.customer.commission/100))
        }else if(this.form.volume_size == 100){
          let cPrice = this.selectedDOsProductType.monthly_price + priceSetting[0].monthly_add_price + priceSetting[0].monthly_extra_price
          price =  cPrice - (cPrice * (this.customer.commission/100))
        }else{
          price = 0
        }
        return Math.ceil(price)
      }
    },
    generatedHourlyCommissionPrice() {
      if(this.form.volume_type == 'HDD'){
        let priceSetting = this.ktDPriceSettings.filter(price => price.type == 'HDD')
        let price = 0
        if(this.form.volume_size == 50){
          let cPrice = this.selectedDOsProductType.hourly_price + priceSetting[0].hourly_add_price
          price =  cPrice - (cPrice * (this.customer.commission/100))
        }else if(this.form.volume_size == 100){
          let cPrice = this.selectedDOsProductType.hourly_price + priceSetting[0].hourly_add_price + priceSetting[0].hourly_extra_price
          price =  cPrice - (cPrice * (this.customer.commission/100))
        }else{
          price = 0
        }
        return Math.ceil(price)
      }else{
        let priceSetting = this.ktDPriceSettings.filter(price => price.type == 'SSD')
        let price = 0
        if(this.form.volume_size == 50){
          let cPrice = this.selectedDOsProductType.hourly_price + priceSetting[0].hourly_add_price
          price =  cPrice - (cPrice * (this.customer.commission/100))
        }else if(this.form.volume_size == 100){
          let cPrice = this.selectedDOsProductType.hourly_price + priceSetting[0].hourly_add_price + priceSetting[0].hourly_extra_price
          price =  cPrice - (cPrice * (this.customer.commission/100))
        }else{
          price = 0
        }
        return Math.ceil(price)
      }
    },
    serverPlatforms(){
      if(this.customer.g_platform && this.customer.d_platform){
        return [
          {label: 'g', value: 'G'},
          {label: 'd', value: 'D'},
        ];
      }else if(this.customer.g_platform){
        return [
          {label: 'g', value: 'G'},
        ];
      }else if(this.customer.d_platform){
        return [
          {label: 'd', value: 'D'},
        ];
      }else{
        return [
          {label: 'g', value: 'G'},
        ];
      }
    },
    getVlan24Price(){
      let price = 0
      if(this.form.billing_type == 'monthly'){
        price =  this.selectedOsProductType?.monthly_price - (this.selectedOsProductType?.monthly_price * (this.customer.commission/100))
      }else if(this.form.billing_type == 'hourly'){
        price =  this.selectedOsProductType?.hourly_price - (this.selectedOsProductType?.hourly_price * (this.customer.commission/100))
      }
      return Math.ceil(price)
    },
    getKtCloudPrice(){
      let price = 0
      if(this.form.billing_type == 'monthly'){
        price =  this.selectedOsProductType && this.selectedOsProductType.monthly_price ? this.selectedOsProductType.monthly_price : 0
      }else if(this.form.billing_type == 'hourly'){
        price =  this.selectedOsProductType && this.selectedOsProductType.hourly_price ? this.selectedOsProductType.hourly_price : 0
      }
      return Math.ceil(price)
    }
  },
  watch: {
    customer() {
      this.loadServerRegions()
      this.loadSshkeypairs()
      this.loadKtTiers()
      this.loadKtImages()
      this.loadKtDPriceSettings()
    }
  },
  created() {
    this.selectedPlatform =  this.serverPlatforms[0]
    this.form.kt_platform = this.selectedPlatform.label
    this.loadServerRegions()
    this.loadSshkeypairs()
    this.loadKtTiers()
    this.loadKtImages()
    this.loadKtDPriceSettings()
  },
  methods: {
    changePlatform(platform) {
      this.selectedPlatform = platform
      this.form.kt_platform = platform.label
      this.loadServerRegions()
      this.loadSshkeypairs()
      this.loadKtTiers()
      this.loadKtImages()
      this.loadKtDPriceSettings()
    },
    loadServerRegions() {
      this.axios.get('/server-regions/'+this.form.kt_platform)
          .then(({data}) => {
            this.serverRegions = data.data
            if(this.serverRegions.length > 0){
              this.selectedRegion =  this.serverRegions[0]
              this.form.server_region_id = this.selectedRegion.id
              if(this.form.kt_platform == 'g'){
                this.fetchServerProductTypes()
              }else{
                this.fetchDServerProductTypes()
              }
            }else{
              this.selectedRegion =  null
              this.form.server_region_id = ''
            }
          })
    },
    loadSshkeypairs() {
      this.axios.get('/ssh-keypairs/'+this.form.kt_platform)
          .then(({data}) => {
            this.sshKeypairs = data.data
          })
    },
    loadKtTiers() {
      this.axios.get('/get-kt-tiers')
          .then(({data}) => {
            this.ktTiers = data.data
            if(this.ktTiers.length > 0){
              this.form.kt_tier_id = this.ktTiers[0].id
            }
          })
    },
    loadKtImages() {
      this.axios.get('/get-kt-images')
          .then(({data}) => {
            this.dImages = data.data
            if(this.dImages.length > 0){
              this.form.kt_d_image_id = this.dImages[0].id
            }
          })
    },
    loadKtDPriceSettings() {
      this.axios.get('/get-kt-d-price-settings')
          .then(({data}) => {
            this.ktDPriceSettings = data.data
          })
    },
    changeRegion(region){
      this.selectedRegion = region
      this.form.server_region_id = this.selectedRegion.id
      if(this.form.kt_platform == 'g'){
        this.fetchServerProductTypes()
      }else{
        this.fetchDServerProductTypes()
      }
    },
    changeOsType(osType){
      if(this.form.kt_platform == 'g'){
        this.form.os_type = osType
        this.fetchServerProductTypes()
      }else{
        this.fetchDServerProductTypes()
      }
    },
    fetchServerProductTypes(){
      let formData = {
        server_region_id: this.form.server_region_id,
        os_type: this.form.os_type,
        kt_platform: this.form.kt_platform,
      };
      this.axios.post('/get-server-product-types', formData)
          .then(({data}) => {
            this.serverProductTypes = data
            if(this.serverProductTypes.length > 0){
              this.selectedProductType =  this.serverProductTypes[0]
            }else{
              this.selectedProductType = null
            }
          })
    },
    changeProductType(productType){
      this.selectedProductType = productType
    },
    stepChange(value){
      if(value == 2 && this.form.kt_platform == 'g'){
        let formData = {
          server_region_id: this.form.server_region_id,
          template_desc: this.selectedProductType?.template_desc,
          kt_platform: this.form.kt_platform,
        };
        this.axios.post('/get-os-product-types', formData)
            .then(({data}) => {
              this.osProductTypes = data
              if(this.osProductTypes.length > 0){
                this.selectedOsProductType =  this.osProductTypes[0]
                this.form.server_product_type_id = this.selectedOsProductType.id
              }else{
                this.selectedOsProductType =  null
                this.form.server_product_type_id = ''
              }
            })
      }else{
        if(this.serverDTypeChildrenList){
          this.osDProductTypes = this.serverDTypeChildrenList.product_types
          if(this.osDProductTypes.length > 0){
            this.selectedDOsProductType =  this.osDProductTypes[0]
            this.form.kt_d_product_type_id = this.selectedDOsProductType.id
          }else{
            this.selectedDOsProductType =  null
            this.form.kt_d_product_type_id = ''
          }
        }else{
          this.osDProductTypes = []
          this.selectedDOsProductType =  null
          this.form.kt_d_product_type_id = ''
        }
      }
      this.step = value
    },
    changeSpecification(){
      let result = this.osProductTypes.filter(e => e.id == this.form.server_product_type_id)
      this.selectedOsProductType = result[0]

    },
    changeDSpecification(){
      let result = this.osDProductTypes.filter(e => e.id == this.form.kt_d_product_type_id)
      this.selectedDOsProductType = result[0]

    },
    cancelOperation(){
      this.$swal({
        title: 'Are you sure want to cancel?',
        text: "It will stop server creation!",
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push('cloud-servers');
        }
      });
    },
    async submit() {
      try {
        this.allErrors = null;
        this.lyLoading = true;

        const anotherApiCallResponse = await this.axios.post('/check-server-name-availability', { server_name: this.form.server_name });

        if (anotherApiCallResponse.data.success) {
          const response = await this.axios.post('/cloud-servers', this.form);

          if (response.data.success) {
            this.showSuccessMsg(response.data.message);
            this.$router.push('cloud-servers');
          } else {
            this.$swal({
              text: response.data.message,
              showCancelButton: false,
              confirmButtonText: 'Close!',
              confirmButtonColor: '#dd4b39',
              reverseButtons: true
            });
          }
        } else {
          this.$swal({
            text: anotherApiCallResponse.data.message,
            showCancelButton: false,
            confirmButtonText: 'Close!',
            confirmButtonColor: '#dd4b39',
            reverseButtons: true
          });
        }
      } catch (err) {
        this.allErrors = err.response?.data?.errors || null;
        this.showFailMsg(err.response?.data?.message || 'An error occurred');
      } finally {
        this.lyLoading = false;
      }
    },
    submitDServerCreation() {
      this.allErrors = null;
      this.lyLoading = true;
      this.form.hourly_price = this.generatedHourlyPrice
      this.form.monthly_price = this.generatedMonthlyPrice
      this.axios.post('/create-kt-d-cloud-server', this.form)
          .then((response) => {
            if(response.data.success){
              this.showSuccessMsg(response.data.message);
              this.$router.push('cloud-servers');
            }else{
              this.$swal({
                text: response.data.message,
                showCancelButton: false,
                confirmButtonText: 'Close!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
              })
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    fetchDServerProductTypes(){
      this.axios.post('/get-kt-d-product-categories')
          .then(({data}) => {
            this.serverDTypes = data
            if(this.serverDTypes.length > 0){
              this.selectedDType =  this.serverDTypes[0]
              if(this.selectedDType.category_children && this.selectedDType.category_children.length > 0){
                this.serverDTypeChildren = this.selectedDType.category_children
                if(this.serverDTypeChildren && this.serverDTypeChildren[0].category_children_list.length > 0){
                  this.serverDTypeChildrenLists = this.serverDTypeChildren[0].category_children_list
                  if(this.serverDTypeChildrenLists.length > 0){
                    this.serverDTypeChildrenList = this.serverDTypeChildren[0].category_children_list[0]
                  }
                }else{
                  this.serverDTypeChildrenList = null
                  this.serverDTypeChildrenLists = []
                }
              }else{
                this.serverDTypeChildren = []
              }
            }else{
              this.selectedDType = null
            }
          })
    },
    changeDType(value){
      this.selectedDType = value
      if(this.selectedDType.category_children && this.selectedDType.category_children.length > 0){
        this.form.os_d_type = this.selectedDType.category_children[0].display_name
        this.serverDTypeChildren = this.selectedDType.category_children
        if(this.serverDTypeChildren && this.serverDTypeChildren[0].category_children_list.length > 0){
          this.serverDTypeChildrenLists = this.serverDTypeChildren[0].category_children_list
          if(this.serverDTypeChildrenLists.length > 0){
            this.serverDTypeChildrenList = this.serverDTypeChildren[0].category_children_list[0]
          }
        }else{
          this.serverDTypeChildrenList = null
          this.serverDTypeChildrenLists = []
        }
      }else{
        this.serverDTypeChildren = []
      }
    },
    changeDOsType(value){
      this.form.os_d_type = value.display_name
      this.serverDTypeChildrenLists = value.category_children_list
      if(this.serverDTypeChildrenLists.length > 0){
        this.serverDTypeChildrenList = this.serverDTypeChildrenLists[0]
      }else{
        this.serverDTypeChildrenList = null
        this.serverDTypeChildrenLists = []
      }
    },
    changeDProductType(value){
      this.serverDTypeChildrenList =  value
      this.osDProductTypes = value.product_types
      if(this.osDProductTypes.length > 0){
        this.selectedDOsProductType =  this.osDProductTypes[0]
        this.form.kt_d_product_type_id = this.selectedDOsProductType.id
      }else{
        this.osDProductTypes = []
        this.selectedDOsProductType =  null
        this.serverDTypeChildrenList =  null
        this.form.kt_d_product_type_id = ''
      }
    },
    openAddSshModal(editId = null) {
      this.editId = editId
      this.isShowContactModal = true;
    },
    closeModal() {
      this.isShowContactModal = false;
    },
    setCreatedRecord(record){
      this.form.ssh_keypair_id = record.id
    },
  }
}
</script>
<style scoped>

</style>